import React from "react";
import PropTypes from "prop-types";

import DesctopCardBlock from "./DesctopCardBlock";

import { useTranslation } from "next-i18next";

const DesctopBlock = ({
  firstHalls,
  secondHalls,
  activeMediaSize,
  activeHallId,
  setActiveHallId,
  ClubHallDescription,
  scheduleDefaultView,
}) => {
  const [t] = useTranslation();

  return (
    <>
      <div className="club-halls-block-desctop">
        {firstHalls.map(({ id, title, address, image, imageTitleEnabled }) => (
          <DesctopCardBlock
            key={id}
            activeMediaSize={activeMediaSize}
            id={id}
            activeHallId={activeHallId}
            title={title}
            setActiveHallId={setActiveHallId}
            image={image}
            address={address}
            imageTitleEnabled={imageTitleEnabled}
            scheduleButton={t("schedule")}
            scheduleDefaultView={scheduleDefaultView}
          />
        ))}
      </div>

      {ClubHallDescription}

      {!!secondHalls?.length && (
        <div className="club-halls-block-desctop">
          {secondHalls.map(
            ({ id, title, address, image, imageTitleEnabled }) => (
              <DesctopCardBlock
                key={id}
                activeMediaSize={activeMediaSize}
                id={id}
                activeHallId={activeHallId}
                title={title}
                setActiveHallId={setActiveHallId}
                image={image}
                address={address}
                imageTitleEnabled={imageTitleEnabled}
                scheduleButton={t("schedule")}
                scheduleDefaultView={scheduleDefaultView}
              />
            )
          )}
        </div>
      )}
    </>
  );
};

DesctopBlock.propTypes = {
  firstHalls: PropTypes.array,
  secondHalls: PropTypes.array,
  countBlocks: PropTypes.array,
  activeHallId: PropTypes.number,
  setActiveHallId: PropTypes.func,
  activeMediaSize: PropTypes.object,
  icon: PropTypes.string,
};

DesctopBlock.defaultProps = {
  firstHalls: [],
  secondHalls: [],
  countBlocks: [],
  activeHallId: -1,
  setActiveHallId: () => {},
  activeMediaSize: {},
  icon: "",
};

export default DesctopBlock;
